import React, { useState, useEffect } from "react";
import RenderDetailQuestions from "./RenderDetailQuestions";
import { Notification } from "../../common/Notification";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const RenderWizardUI = (props: any) => {
    const location = useLocation();
    const { t: tLang } = useTranslation();
    const [renderDetailQuestions, setRenderDetailQuestions] = useState(false);
    const [errorMessage, setErrorMessage] = useState(tLang("resourcesSection.securityAssessmentTab.errMsg2"));

    const submitButtonText = props.currentPosition === props.numberOfQuestion - 1 ? tLang("resourcesSection.securityAssessmentTab.finishAssessmentBtnText") : tLang("resourcesSection.securityAssessmentTab.nextBtnText");

    const PreviousButton = () => {
        if (renderDetailQuestions) {
            setRenderDetailQuestions(false);
        } else {
            props.previousCallBack();
        }
    };

    const NextButton = () => {
        if (props.question[props.position].answer === "yes") {
            setRenderDetailQuestions(true);
            setErrorMessage(tLang("resourcesSection.securityAssessmentTab.errMsg1"));

            if (renderDetailQuestions) {
                if (isAllDetailAnsGiven()) props.nextCallback();
                else showErrorMessage();
            }
        } else {
            if (props.question[props.position].answer === "no") {
                setErrorMessage(tLang("resourcesSection.securityAssessmentTab.errMsg2"));
                setRenderDetailQuestions(false);
                props.nextCallback();
            } else {
                showErrorMessage();
            }
        }
    };

    const showErrorMessage = () => {
        Notification({
            type: "error",
            title: tLang("resourcesSection.securityAssessmentTab.securityAssessmentTitle"),
            message: errorMessage,
            duration: 5,
        });
    };

    const handleFirstAnswerSelection = (e: any) => {
        const { id } = e.target;
        let ans = {} as any;
        var checkedYes = id.split("_")[2] === "yes";
        ans[id.split("_")[1]] = checkedYes;
        props.question[props.position].answer = id.split("_")[2];

        props.setAnswer(ans);
    };

    const isAllDetailAnsGiven = () => {
        let allAnsGiven = true;
        props.question[props.position].AnswerSchema.AnswerSchema.forEach((ans: any) => {
            if (Object.keys(props.answer).includes(ans.Id + "") === false) {
                allAnsGiven = false;
            }
        });
        return allAnsGiven;
    };

    const setAnswer = (ans: any) => {
        props.setAnswer(ans);
    };

    const assessmentProgress = () => {
        let currentPosition = props.position + 1;
        const query = new URLSearchParams(location.search);
        const id = query.get("parentID");
        if (id && id.length > 0) {
            currentPosition = props.allQuestions?.findIndex((it: any) => it.Id === id) + 1;
        }

        return tLang("resourcesSection.securityAssessmentTab.question") + currentPosition + tLang("resourcesSection.securityAssessmentTab.of") + props.allQuestions?.length;
    };

    useEffect(() => {
        if (props.question && props.question[props.position].answer === "yes") setRenderDetailQuestions(true);
        else setRenderDetailQuestions(false);
    }, [props]);

    return (
        <React.Fragment>
            {props.question && (
                <div key={props.question[props.position].Id}>
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-text">
                                <h2 className="box-title">{props.question[props.position].Title}</h2>
                            </div>
                        </div>
                        <div className="box-content">
                            <p>
                                <strong>{assessmentProgress()}</strong>
                            </p>
                            <p>{props.question[props.position].Details}</p>
                            <form id="form-question-1" className="margin-top-s form-questions">
                                {!renderDetailQuestions && (
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <legend className="legend-label">{props.question[props.position].Question}</legend>
                                            </div>

                                            <div className="col-xs-12 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className="form-row no-margin">
                                                            <div className="form-input">
                                                                <label className="form-radio-label">
                                                                    <input
                                                                        type="radio"
                                                                        id={"question_" + props.question[props.position].Id + "_yes"}
                                                                        name={"question_" + props.question.Id}
                                                                        defaultChecked={props.question[props.position].answer === "yes"}
                                                                        onChange={(e) => handleFirstAnswerSelection(e)}
                                                                    />
                                                                    <span className="form-radio-label-text">{tLang("resourcesSection.securityAssessmentTab.yesBtnText")}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className="form-row no-margin">
                                                            <div className="form-input">
                                                                <label className="form-radio-label">
                                                                    <input
                                                                        type="radio"
                                                                        id={"question_" + props.question[props.position].Id + "_no"}
                                                                        name={"question_" + props.question.Id}
                                                                        defaultChecked={props.question[props.position].answer === "no"}
                                                                        onChange={(e) => handleFirstAnswerSelection(e)}
                                                                    />
                                                                    <span className="form-radio-label-text">{tLang("resourcesSection.securityAssessmentTab.noBtnText")}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                )}
                                {renderDetailQuestions && <RenderDetailQuestions questions={props.question[props.position].AnswerSchema} setAnswer={setAnswer} />}
                                <div className="margin-top-xl"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter">
                                        {(renderDetailQuestions === true || props.position > 0) && (
                                            <button type="button" onClick={PreviousButton} className="btn-default btn-primary-outline btn-min-width">
                                                <span className="btn-text">{tLang("resourcesSection.securityAssessmentTab.backBtnText")}</span>
                                            </button>
                                        )}
                                    </div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <button type="button" onClick={NextButton} className="btn-default btn-primary btn-min-width">
                                            <span className="btn-text">{submitButtonText}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default RenderWizardUI;
